<div ngbDropdown class="vox-dropdown-input">
  <button type="button"
    ngbDropdownToggle>{{ selectedPlatform?.full_name }}</button>
  <div ngbDropdownMenu>
    <button type="button" ngbDropdownItem *ngFor="let platform of platforms"
      (click)="selectPlatform(platform)">{{platform?.full_name}}</button>
  </div>
</div>
